/** @format */

import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import AdminHome from "../Component/Admin/Dashboard/default/AdminHome";
import DynamicModelRouter from "./DynamicModelRouter";
import DocViewer from "../Component/Dashboard/PLAN01/TabDocs/DocViewer";
import Import from "../Component/Dashboard/Import/Import";
import ModelsVideoCodage from "../Component/Dashboard/Default/VideoCodage/ModelsVideoCodage";
import AdmDocStatus from "../Component/Admin/Dashboard/default/AdmDocStatus/AdmDocStatus";
import MassUpdate from "../Component/Admin/Dashboard/default/AdmMassUpdate/AdmMassUpdate";
import AdmDocId from "../Component/Admin/Dashboard/default/AdmDocId/AdmDocId";
import DemoInvoice from "../Component/Dashboard/CompletedImport/CompletedImport";
import Cookies from "js-cookie";

export default function RouterUser() {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");

  if (!token || role !== "superadmin") {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      Cookies.remove(cookieName);
    });
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Routes>
        <Route index element={<AdminHome />} />

        <Route path=":configKey" element={<DynamicModelRouter />} />

        <Route path="DocStatus" element={<AdmDocStatus />} />
        <Route path="MassUpdate" element={<MassUpdate />} />
        <Route path="DocId" element={<AdmDocId />} />
        <Route path="DocView" element={<DocViewer />} />
        <Route path="Import" element={<Import />} />
        <Route path="/DemoInvoice" element={<DemoInvoice />} />
        <Route path="ModelsVideoCodage" element={<ModelsVideoCodage />} />

        <Route path="*" element={<Navigate to="/Admin" replace />} />
      </Routes>
    </>
  );
}